import styled from "@emotion/styled"

const Container = styled('div')(() => ({
    position: 'relative',
    height: '1550px',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1,
    background: '#f5f5f5',
}))

export default Container 
